import { render, staticRenderFns } from "./GroupVideos.vue?vue&type=template&id=399c82c2&"
import script from "./GroupVideos.vue?vue&type=script&lang=js&"
export * from "./GroupVideos.vue?vue&type=script&lang=js&"
import style0 from "./GroupVideos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports